import * as yup from 'yup'
import {getTypeDocument} from '../util/functions'
import {isDocTypeFlexibleLength} from '../util/documentTypeHelpers'

export const user = yup.object().shape({
  tipoDocumentoId: yup.string().required('El tipo de documento es obligatorio'),
  numeroDocumento: yup
    .string()
    // .test({
    //   name: 'dynamicValidation',
    //   message: 'Cantidad de carácteres no validos',
    //   test: async function (texto) {
    //     const tipo = this.parent.tipoDocumentoId
    //     if (!tipo || tipo === '00') {
    //       return true
    //     }
    //     const maxLengthOptions = await getTypeDocument()
    //     const tipoDocumento = maxLengthOptions.find((item) => item.value === tipo)
    //     if (!tipoDocumento) {
    //       return true
    //     }
    //     const length = tipoDocumento.length
    //     const length2 = tipoDocumento.length2

    //     if (tipo === '00') {
    //       if (texto && Number(texto.length) < 7) {
    //         return this.createError({
    //           message: `Por favor, no escribas menos de 7 caracteres.`, // Modifica el mensaje de error
    //           path: this.path,
    //         })
    //       }
    //     } else if (tipo === '01') {
    //       if (texto && texto.length !== Number(length)) {
    //         return this.createError({
    //           message: `Por favor, no ingrese menos de ${length} caracteres.`,
    //           path: this.path,
    //         })
    //       }
    //     } else {
    //       if (texto && (texto.length < Number(length) || texto.length > Number(length2))) {
    //         return this.createError({
    //           message: `Por favor, ingrese entre ${length} y ${length2} caracteres.`,
    //           path: this.path,
    //         })
    //       }
    //     }
    //     return true
    //   },
    // })
    .required('Campo requerido'),
  usuario: yup.string().required('El usuario es obligatorio'),
  telefono: yup.string().required('El teléfono es obligatorio'),
  email: yup.string().required('El correo es obligatorio').email('Formato de email invalido'),
  email2: yup.string().email('Formato de email invalido'),
  estado: yup.string().required('El estado es obligatorio'),
  empresaSubcontratistaId: yup.string().required('La empresa subcontratista es obligatoria'),
  empresaContratanteId: yup.string().required('La empresa contratante es obligatoria'),
  documentoPersonaIdentificadorId: yup.string().required('El código es obligatorio'),
  centroCosto: yup.string().required('CECO es obligatorio'),
})

export const personUser = yup.object().shape({
  person: yup.object().shape({
    tipoDocumento: yup.string().required('El tipo de documento es obligatorio'),
    numeroDocumento: yup
      .string()
      .test({
        name: 'dynamicValidation',
        message: 'Cantidad de carácteres no validos',
        test: async function (texto) {
          const tipo = this.parent.tipoDocumento
          const maxLengthOptions = await getTypeDocument()
          if (!tipo || isDocTypeFlexibleLength(tipo, maxLengthOptions)) {
            if (texto && tipo && Number(texto.length) < 7) {
              return this.createError({
                message: `Por favor, no escribas menos de 7 caracteres.`,
                path: this.path,
              })
            }
            return true
          }
          const tipoDocumento = maxLengthOptions.find((item) => item.value === tipo)
          if (!tipoDocumento) {
            return true
          }
          const length = tipoDocumento.length
          const length2 = tipoDocumento.length2

          if (tipo === '01') {
            if (texto && texto.length !== Number(length)) {
              return this.createError({
                message: `Por favor, no ingrese menos de ${length} caracteres.`,
                path: this.path,
              })
            }
          } else {
            if (texto && (texto.length < Number(length) || texto.length > Number(length2))) {
              return this.createError({
                message: `Por favor, ingrese entre ${length} y ${length2} caracteres.`,
                path: this.path,
              })
            }
          }

          return true
        },
      })
      .required('Campo requerido'),
    nombres: yup.string().required('El nombre es obligatorio'),
    apellidoMaterno: yup.string().required('El apellido materno es obligatorio'),
    apellidoPaterno: yup.string().required('El apellido paterno es obligatorio'),
    email: yup.string().email('Formato de email invalido'),
    estado: yup.string().required('El estado es obligatorio'),
    sexoId: yup.string().required('El sexo es obligatorio'),
  }),
})
